module.exports = __webpack_public_path__ + "static/media/glass-splash.940f23cd.png";